import React, { useEffect, useRef, useState } from "react";
import CaretDown from "./Icons/CaretDown";

const Selectbox = ({ placeHolder, options, isMulti, isSearchable, onChange, align, currentValue, allowClear = false }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [selectedValue, setSelectedValue] = useState(isMulti ? ([ ...currentValue ] || []) : currentValue || null);
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();
    const dropdownRef = useRef();
    const id = `id-${Math.floor(Math.random() * 100)}`

    useEffect(() => {
        if (isMulti) {
            return;
        }
        
        const preSelectedOption = options.find((option) => option.selected || option.value === currentValue || option == currentValue);
        if (preSelectedOption) {
            setSelectedValue(preSelectedOption || null);
        }
        
    }, [options]);

    const toggleMenu = () => {
        setShowMenu((prev) => !prev);
    };

    const handleOptionSelect = (option) => {
        let newValue;
        if (isMulti) {
            if (selectedValue.some((o) => o.value === option.value)) {
                newValue = selectedValue.filter((o) => o.value !== option.value);
            } 
            else {
                newValue = [...selectedValue, option];
            }
        } 
        else {
            newValue = option;
        }

        setSelectedValue(newValue);

        if (!isMulti) {
            setShowMenu(false); // Close menu for single select
        }

        if (onChange) {
            // Call the onChange callback if provided
            onChange?.(newValue);
        }
        else if (option.value) {
            // If no onChange callback is provided, navigate to the selected option
            window.location.href = option.value;
        }
    };

    const handleClearSelection = () => {
        setSelectedValue(isMulti ? [] : null);
        setShowMenu(false);
        onChange?.(isMulti ? [] : null); // Notify parent component of the change
    };

    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            const items = Array.from(dropdownRef.current.querySelectorAll('[role="menuitem"]'));
            const currentIndex = items.findIndex((item) => item === document.activeElement);
            const nextIndex = e.key === "ArrowDown" ? currentIndex + 1 : currentIndex - 1;
            const focusItem = items[nextIndex] || (e.key === "ArrowDown" ? items[0] : items[items.length - 1]);
            focusItem?.focus();
        }
        if (e.key === "Escape") {
            setShowMenu(false);
        }
    };

    const handleMenuBlur = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.relatedTarget)) {
            setShowMenu(false);
        }
    };

    const getDisplayValue = () => {
        if (isMulti && selectedValue.length > 0) {
            return selectedValue.map((option) => option.label).join(", ");
        }

        return selectedValue?.label || placeHolder;
    };

    return (
        <div className={`dropdown dropdown--${align || "auto"}`} onBlur={handleMenuBlur}>
            <button
                className={`dropdown__toggle ${selectedValue ? "dropdown__toggle--selected" : ""} button`}
                onClick={toggleMenu}
                aria-haspopup="true"
                aria-expanded={showMenu}
                aria-controls={id}
                type="button"
            >
                {getDisplayValue()} 
                <CaretDown isOpen={showMenu} />
            </button>

            {showMenu && (
                <div
                    className="dropdown__menu"
                    id={id}
                    role="menu"
                    ref={dropdownRef}
                    onKeyDown={handleKeyDown}
                >
                    {isSearchable && (
                        <div className="dropdown__search-box">
                            <input
                                className="form-control"
                                onChange={(e) => setSearchValue(e.target.value)}
                                value={searchValue}
                                ref={searchRef}
                                placeholder="Search..."
                            />
                        </div>
                    )}

                    {options
                        .filter((option) => option.label.toLowerCase().includes(searchValue.toLowerCase()))
                        .map((option) => (
                            <button
                                key={option.value}
                                role="menuitem"
                                tabIndex="0"
                                type="button"
                                className={`dropdown__item ${selectedValue?.value === option.value || (isMulti && selectedValue.some((o) => o.value === option.value)) ? "dropdown__item--selected" : ""}`}
                                onClick={() => handleOptionSelect(option)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        handleOptionSelect(option);
                                    }
                                }}
                            >
                                {option.label}
                            </button>
                    ))}

                    {allowClear && selectedValue && (
                        <button
                            type="button"
                            role="menuitem"
                            className="dropdown__item dropdown__item--clear button"
                            onClick={handleClearSelection}
                            aria-label="Rensa val">
                            Rensa val
                        </button>
                    )}

                </div>
            )}
        </div>
    );
};

export default Selectbox;
